<template>
  <!-- MAIN CONTENT
    ================================================== -->
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <!-- Image -->
      <!-- <img src="../../public/img/covers/profile-cover-1.jpg" class="header-img-top" alt="..."> -->

      <div class="container-fluid">
        <!-- Body -->
        <div class="header-body mt-n5 mt-md-n6">
          <div class="row align-items-end">
            <div class="col-auto">
              <!-- Avatar -->
              <div class="avatar avatar-xl header-avatar-top">
                <img
                  src="../../public/img/avatars/profiles/avatar-1.jpg"
                  alt="..."
                  class="avatar-img rounded-circle border border-4 border-body"
                />
              </div>
            </div>
            <div class="col mb-3 ml-n3 ml-md-n2">
              <!-- Pretitle -->
              <h6 class="header-pretitle">
                {{ perfil.Status }}
              </h6>

              <!-- Title -->
              <h1 class="header-title">
                {{ perfil.Username }}
              </h1>
            </div>
          </div>
          <!-- / .row -->
        </div>
        <!-- / .header-body -->
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-8">
          <!-- Card -->
          <div class="card">
            <div class="card-body">
              <!-- List group -->
              <div v-for="(value, key) in perfil" :key="key">
                <div class="list-group list-group-flush my-n3">
                  <div class="list-group-item">
                    <div class="row align-items-center">
                      <div class="col">
                        <!-- Title -->
                        <h5 class="mb-0">
                          {{ key }}
                        </h5>
                      </div>
                      <div class="col-auto">
                        <!-- Time -->
                        <time class="small text-muted" datetime="1988-10-24">
                          {{ value }}
                        </time>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- / .row -->
    </div>
    <!-- CONTENT -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-lg-4" v-for="x in produtos" :key="x.id">
          <!-- Card -->
          <div class="card">
            <div class="card-body">
              <!-- Title -->
              <h6 class="text-uppercase text-center text-muted my-4">
                {{ x.nome }}
              </h6>

              <!-- Price -->
              <div
                class="row no-gutters align-items-center justify-content-center"
              >
                <div class="col-auto">
                  <div class="h2 mb-0">R$</div>
                </div>
                <div class="col-auto">
                  <div class="display-2 mb-0">{{ x.valor }}</div>
                </div>
              </div>
              <!-- / .row -->

              <!-- Period -->

              <!-- Features -->
              <div class="mb-3">
                <ul class="list-group list-group-flush">
                  <li
                    class="
                      list-group-item
                      d-flex
                      align-items-center
                      justify-content-between
                      px-0
                    "
                  >
                    <small
                      >Acompanhar ao vivo pelo discord todas as entradas sem
                      delay quando em live.</small
                    >
                    <i class="fe fe-check-circle text-success"></i>
                  </li>
                  <li
                    class="
                      list-group-item
                      d-flex
                      align-items-center
                      justify-content-between
                      px-0
                    "
                  >
                    <small>Participar do grupo do Telegram</small>
                    <i class="fe fe-check-circle text-success"></i>
                  </li>

                  <li
                    class="
                      list-group-item
                      d-flex
                      align-items-center
                      justify-content-between
                      px-0
                    "
                  >
                    <small
                      >Acesso a todas as análises do dia (Lol, Valorant, CS e
                      Futebol)</small
                    >
                    <i class="fe fe-check-circle text-success"></i>
                  </li>
                  <li
                    class="
                      list-group-item
                      d-flex
                      align-items-center
                      justify-content-between
                      px-0
                    "
                  >
                    <small
                      >As melhores dicas estatísticas de secundárias de League
                      of Legends</small
                    >
                    <i class="fe fe-check-circle text-success"></i>
                  </li>
                </ul>
              </div>

              <!-- Button -->
              <input
                type="text"
                class="form-control form-control-rounded"
                placeholder="Cupom de desconto"
                v-model="cupom"
              />

              <a
                href="#"
                class="btn btn-block btn-primary"
                @click.prevent="criarlink(x.id)"
                style="margin-top: 15px"
                >Comprar/Renovar</a
              >
              <!-- <a href="https://api.whatsapp.com/send?phone=5538988138328&text=Gostaria%20de%20Assinar%20o%20plano%20Vip" class="btn btn-block btn-primary" @click="criarlink()">
                  Comprar!
                </a>-->
            </div>
          </div>
        </div>
        <!-- <div class="col-12 col-xl-8">
          <div class="card">
            <div class="card-body">
              <PassChange />
            </div>
          </div>
        </div> -->
      </div>
      <!-- / .row -->
    </div>
  </div>
  <!-- / .main-content -->
</template>

<script>
import axios from 'axios'

export default {
    data: function(){
        return {
            perfil: {},
            produtos: {},
            cupom: ''
        }
    },
    components: {
        
    },
    mounted(){
        const config = {
            headers: {
        // Set your Authorization to 'JWT', not Bearer!!!
        Authorization: `JWT ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
        },
        }
        axios.get('account/profile', config)
        .then(resp=>{
            this.perfil = resp.data            
        })
        .catch(err=>{
            console.log(err)
        })
        axios.get('dinheiros/produto/', config)
        .then(resp=>{
            console.log(resp.data)
            this.produtos= resp.data
        })
        .catch(err=>{
            console.log(err)
        })
    },
    methods:{
        criarlink(id){
        const config = {
            headers: {
        // Set your Authorization to 'JWT', not Bearer!!!
        Authorization: `JWT ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
        },
        }
        var data = {
          cupom: this.cupom,
          id: id
        }
        axios.post(`dinheiros/get_transactionv2/`,data,config)
        .then(resp => {
          var link = resp.data
          window.open(link, '_blank')
        })
        .catch(err =>{
          console.log(err.response.data)
          this.$notify.error(err.response.data);
        })
      }
    }
}
</script>

<style scoped>
.main-content {
  margin-top: 60px;
}
</style>
